import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import Box from 'components/Box';
import Panel from 'components/Panel';
import Button from 'components/Button';
import Card from 'components/Card';
import Modal from 'components/Modal';
import Text from 'components/Text';
import ModalHeadline from 'components/ModalHeadline';
import ErrorBoundary from 'components/ErrorBoundary';
import BulletList from 'components/BulletList';

const rulesTranslationKeys = [
	'panel_mark_as_done_explanation_rule1',
	'panel_mark_as_done_explanation_rule2',
	'panel_mark_as_done_explanation_rule3',
];

export default function MarkAsDoneExplanationModal({onClose}) {
	const {t} = useTranslation();
	const titleId = 'mark-as-done-explanation-title';

	return (
		<Modal
			id="mark-as-done-explanation"
			aria-labelledby={titleId}
			onRequestClose={onClose}
		>
			<ErrorBoundary>
				<Card variant="raised">
					<ModalHeadline
						onClose={onClose}
						titleId={titleId}
						title={t('panel_mark_as_done_explanation_title')}
					/>
					<Panel>
						<Box pb="xs">
							<Text>
								{t(
									'panel_mark_as_done_explanation_introduction_colon'
								)}
							</Text>
						</Box>
						<Box pb="xs">
							<BulletList>
								{rulesTranslationKeys.map(key => t(key))}
							</BulletList>
						</Box>
					</Panel>
					<Panel>
						<Box textAlign="center">
							<Button variant="primary" onClick={onClose}>
								{t('actions_got_it')}
							</Button>
						</Box>
					</Panel>
				</Card>
			</ErrorBoundary>
		</Modal>
	);
}

MarkAsDoneExplanationModal.propTypes = {
	onClose: PropTypes.func.isRequired,
};
